// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"857453ca","349":"29afdb1a","525":"16dbcc59","732":"3b1bd336","790":"c7b8187d","873":"e6a07316","895":"97b66b52","977":"58f41797"}[chunkId] + ".chunk.js";
};